import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
  useCallback,
} from "react";
import NumberFormat from "react-number-format";
import { roundAmount } from "../../helpers/currencyConversion";
import { useSelector } from "react-redux";
import { Toast } from "../UI/toast/Toast";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
// eslint-disable-next-line import/no-unresolved
import { checkUserToken } from "../../helpers/api/auth";
import {
  fetchDebtsToPayProvider,
  fetchOneAliquotByProperty,
  fetchDebtsToPayAsPropertyCuentaPendingPeriodTest,
} from "../../helpers/api/finance";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import PageHeader from "../common/PageHeader";
import Logo from "../navbar/Logo";
import SupportLink from "../root/support/components/SupportLink";
import { useReactToPrint } from "react-to-print";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { isIterableArray } from "../../helpers/utils";
import html2canvas from "html2canvas";
// eslint-disable-next-line import/no-named-as-default
import jsPDF from "jspdf";
import { useLocation, useParams } from "react-router-dom";
import { CurrencyContext } from "../../context/Context";
import { findOneConfig } from "../../helpers/api/condominium";
import useSWRFetch from "../../helpers/hooks/useSWRFetch";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faInfoCircle,
  faSearch,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { fetchCondominiumBanksAll } from "../../helpers/api/banks";
import classNames from "classnames";
import moment from "moment";
import { formatPlanillaDate, planillaDueDate } from "../../helpers/planillaDates";
import { sortByExpenseDate } from "../../helpers/sortByExpenseDate";

const PropertyPaymentDetail = () => {
  const { id: paramCondoId, debtReceivedId } = useParams();
  const location = useLocation();
  const locationState = location?.state || {};
  const initialDebt = locationState.debt || null;
  const initialCost = locationState.cost || null;
  const [debt, setDebt] = useState(initialDebt);
  const [cost, setCost] = useState(initialCost);

  const reportRef = useRef();
  const { role, token } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const [userData, setUserData] = useState({});
  const [username, setUsername] = useState("");
  const [loadingg, setLoading] = useState(true);
  const [aliquots, setAliquots] = useState(null);
  const condominiumState = useSelector((state) => state);
  const [error, setError] = useState(null);

  const { data: dataConfig, isLoading: loadingConfig } = useSWRFetch(
    selectedCondominium,
    findOneConfig
  );

  const [property, setProperty] = useState(null);

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);

  const [viewMode, setViewMode] = useState("condominium");
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  // HO-TASK-255: la tasa de cada cuota la resuelve el backend con la fecha del
  // gasto (`exchange_rate`, misma regla que el reporte de la planilla). Antes
  // se buscaba acá contra el catálogo de tasas y, si faltaba, se pedía la de
  // ese día a un servicio externo por cada fila.
  const getRateForRow = (row) => Number(row?.exchange_rate?.value) || 0;

  // Total en bolívares de una sección: cada cuota a la tasa de su fecha.
  const getConvertedTotal = (rows) =>
    (rows || []).reduce(
      (sum, row) =>
        sum +
        (row?.amount_converted !== undefined && row?.amount_converted !== null
          ? Math.abs(Number(row.amount_converted) || 0)
          : Math.abs(Number(row?.amount) || 0) * getRateForRow(row)),
      0
    );

  // El total a pagar sí va a la tasa del día: es lo que el propietario paga
  // hoy. La nota debajo dice de qué día es esa tasa.
  const activeRateDateLabel = moment(debt?.exchange_rate?.date || curr?.date || curr?.created_at || undefined).format("DD MMM YYYY");

  const propertiesList = React.useMemo(() => {
    if (!debt?.accounts) return [];
    const map = new Map();
    debt.accounts.forEach((acc) => {
      const p = acc.property;
      if (p && p.id && !map.has(p.id)) {
        map.set(p.id, {
          id: p.id,
          property: p.property,
          aliquot: acc.aliquot || p.aliquot || 0,
          user: p.user || cost?.user,
        });
      }
    });
    return Array.from(map.values());
  }, [debt, cost]);

  const activeProperty = React.useMemo(() => {
    if (!propertiesList.length) return null;
    if (selectedPropertyId) {
      return (
        propertiesList.find((p) => p.id === selectedPropertyId) ||
        propertiesList[0]
      );
    }
    return propertiesList[0];
  }, [propertiesList, selectedPropertyId]);

  const [report, setReport] = useState([]);
  const [reportE, setReportE] = useState([]);
  const [reportI, setReportI] = useState([]);
  const [funds, setFunds] = useState([]);
  const [reportIncomes, setReportIncomes] = useState([]);
  const [amount, setAmount] = useState(0);
  const [amountE, setAmountE] = useState(0);
  const [amountI, setAmountI] = useState(0);
  const [amountF, setAmountF] = useState(0);
  const [amountIncomes, setAmountIncomes] = useState(0);

  const [banks, setBanks] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(true);
  const [errorBanks, setErrorBanks] = useState(null);

  const [paramsBanks, setParamsBanks] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const fetchApiBanks = useCallback(async () => {
    setLoadingBanks(true);
    setErrorBanks(null);

    try {
      const response = await fetchCondominiumBanksAll(paramsBanks);
      setBanks(response.data && response.data.length >= 0 ? response.data : []);
    } catch (error) {
      setErrorBanks(error);
      setBanks([]);
    } finally {
      setLoadingBanks(false);
    }
  }, [paramsBanks]);

  useEffect(() => {
    fetchApiBanks();
  }, [fetchApiBanks, paramsBanks]);

  const fetchApireports = useCallback(async () => {
    if (!debt) return;
    try {
      // type.id 5 = "Deuda Inicial" (saldo inicial importado): se muestra junto
      // a los gastos ordinarios, no como extraordinario (ver TypeFinancesSeeder).
      const financeType1Reports = debt?.accounts?.filter(
        (report) =>
          report.finance !== null &&
          (report?.finance?.type?.id === 1 || report?.finance?.type?.id === 5)
      );
      const financeType2Reports = debt?.accounts?.filter(
        (report) =>
          (report.finance !== null && report?.finance?.type?.id === 2) ||
          (!report.income_id &&
            !report.reserve_fund &&
            !report.reserve_fund_payment_id &&
            Number(report.amount) > 0 &&
            report?.finance?.type?.id !== 1 &&
            report?.finance?.type?.id !== 3 &&
            report?.finance?.type?.id !== 5)
      );

      const financeType3Reports = debt?.accounts?.filter(
        (report) => report.finance !== null && report?.finance?.type?.id === 3
      );
      const reserveReports = debt?.accounts?.filter(
        (report) => report.reserve_fund !== null
      );
      const incomeReports = debt?.accounts?.filter(
        (report) =>
          Boolean(report.income_id) ||
          Boolean(report.income) ||
          Number(report.amount) < 0
      );

      setReport(sortByExpenseDate(financeType1Reports));
      setReportE(sortByExpenseDate(financeType2Reports));
      setReportI(sortByExpenseDate(financeType3Reports));
      setFunds(reserveReports ?? []);
      setReportIncomes(incomeReports ?? []);
    } catch (error) {
      console.log(error);
      setReport([]);
    }
  }, [debt]);

  useEffect(() => {
    fetchApireports();
  }, [fetchApireports, debt]);

  // HO-TASK-247: los subtotales se guardan con todos sus decimales. Antes cada
  // uno se redondeaba a 2 al calcularlo y finalTotal sumaba esos redondeos, así
  // que el total podía no coincidir con la suma real de las filas (los montos
  // se guardan con 6 decimales en la base). Mostrar con 2 decimales es cosa de
  // NumberFormat, no del cálculo.
  useEffect(() => {
    const safeAmount = (value) => Number(value || 0);

    // Gasto ordinario
    const monto = report.reduce((a, c) => {
      return a + safeAmount(c?.amount);
    }, 0);
    setAmount(Number(roundAmount(monto) || 0));

    // Gasto extraordinario

    const montoE = reportE.reduce((a, c) => {
      return a + safeAmount(c?.amount);
    }, 0);
    setAmountE(Number(roundAmount(montoE) || 0));

    // Gasto individual

    const montoI = reportI.reduce((a, c) => {
      return a + safeAmount(c?.amount);
    }, 0);
    setAmountI(Number(roundAmount(montoI) || 0));

    // Fondo de reserva

    const montoF = funds.reduce((a, c) => {
      return a + safeAmount(c?.amount);
    }, 0);
    setAmountF(Number(roundAmount(montoF) || 0));

    // Ingresos aplicados
    const montoInc = reportIncomes.reduce((a, c) => {
      return a + Math.abs(safeAmount(c?.amount));
    }, 0);
    setAmountIncomes(Number(roundAmount(montoInc) || 0));
  }, [report, reportE, reportI, funds, reportIncomes]);

  const finalTotal = React.useMemo(() => {
    if (debt?.total !== undefined && debt?.total !== null) {
      return Number(debt.total);
    }
    return Number(
      roundAmount(
        Number(amount) + Number(amountE) + Number(amountI) + Number(amountF) - Number(amountIncomes)
      ) || 0
    );
  }, [debt?.total, amount, amountE, amountI, amountF, amountIncomes]);

  // total_paid solo se actualiza cuando un pago es aprobado (ver
  // BillToPayController::update), así que sumar esos campos ya refleja
  // únicamente lo confirmado, sin necesidad de mirar el estatus de cada pago.
  const totalPaidFromAccounts = React.useMemo(() => {
    return [...report, ...reportE, ...reportI, ...funds].reduce(
      (a, c) => a + Number(c?.total_paid || 0),
      0
    );
  }, [report, reportE, reportI, funds]);

  const pendingAmount =
    debt?.total_amount !== undefined && debt?.total_amount !== null
      ? Number(debt.total_amount)
      : Math.max(0, finalTotal - totalPaidFromAccounts);
  const paidAmount = Math.max(0, finalTotal - pendingAmount);
  const isFullyPaid = pendingAmount <= 0;
  const balanceBadge = isFullyPaid
    ? { label: "Pagado", className: "badge-soft-success" }
    : { label: "Pendiente", className: "badge-soft-warning" };

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
    importStyles: true,
  });

  const [params, setParams] = useState({
    status: null,
    condominiumId: selectedCondominium,
    start_date: null,
    end_date: null,
  });

  const { data, isLoading } = useSWRFetchPaginationProperty(
    fetchDebtsToPayProvider,
    params
  );

  const activeCondoId = paramCondoId || selectedCondominium;

  useEffect(() => {
    if (!debt && debtReceivedId && activeCondoId) {
      (async () => {
        try {
          const res = await fetchDebtsToPayAsPropertyCuentaPendingPeriodTest(1, 10, {
            condominiumId: activeCondoId,
            period_id: debtReceivedId,
          });
          if (res?.data && res.data.length > 0) {
            setDebt(res.data[0]);
          }
        } catch (err) {
          console.error("Error al cargar detalles de la planilla:", err);
        }
      })();
    }
  }, [debt, debtReceivedId, activeCondoId]);

  useEffect(() => {
    let isMounted = true;
    if (debt && debt.accounts && debt.accounts.length > 0) {
      (async () => {
        try {
          const propId = debt.accounts[0]?.property?.id || debt.accounts[0]?.property_id;
          if (propId) {
            const { data } = await fetchOneAliquotByProperty(propId);
            isMounted && setAliquots(data);
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      })();
    }
    return () => { isMounted = false; };
  }, [debt]);

  const loadData = () => {
    setUserData({});
    setLoading(true);
    checkUserToken(token)
      .then(({ username, data, property }) => {
        setUsername(username);
        setUserData(data);
        setProperty(property);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
    return () => setUserData({});
    // eslint-disable-next-line
  }, []);

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Cuenta por pagar de un propietario.pdf");
  };

  useEffect(() => {
    if (role === "property") {
      const getMyProfile = async () => {
        try {
          const data = await checkUserToken(token);
          setProperty(data);
        } catch (error) {
          Toast.fire({
            title:
              "Ha ocurrido un error al obtener los datos, por favor intente nuevamente más tarde.",
            type: "error",
          });
        }
      };
      getMyProfile();
    }
    // eslint-disable-next-line
  }, []);

  const fechaEmision = debt?.accounts?.[0]?.created_at;
  const fechaFormateada = formatPlanillaDate(planillaDueDate(debt?.end_at, fechaEmision));
  const fechaFormateadaE = formatPlanillaDate(fechaEmision);
  const planillaNote = debt?.note ?? dataConfig?.data?.note;

  return (
    <Fragment>
      <PageHeader
        title="Detalle de cuenta por pagar"
        titleTag="h2"
        description={
          role === "property"
            ? "Visualiza tu pago realizado."
            : "Visualiza la cuenta del propietario"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <>
        <PreloadState cond={Boolean(debt)} loading={isLoading}>
          <Fragment>
            <Card className="mb-3">
              <CardBody>
                <Row className="justify-content-end align-items-center d-flex">
                  <Col
                    xs="auto"
                    lg={"auto"}
                    md={12}
                    className="justify-self-end d-flex justify-content-end align-items-center"
                  >
                    <ButtonIcon
                      color="falcon-default"
                      size="sm"
                      icon="arrow-down"
                      onClick={handleDownload}
                      disabled={!data}
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Descargar (.pdf)
                    </ButtonIcon>
                    <ButtonIcon
                      onClick={handlePrint}
                      color="falcon-default"
                      size="sm"
                      icon="print"
                      disabled={!data}
                      className="mr-2 mb-2 mb-sm-0"
                    >
                      Imprimir
                    </ButtonIcon>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card
              innerRef={(e) => {
                reportRef.current = e;
              }}
            >
              <CardBody>
                {/*  <PreloadState cond={isIterableArray(debt)} loading={isLoading}> */}
                <ItemImageTitleSubProperty
                  image={dataConfig?.data?.logo}
                  title1={"Planilla de liquidación de gastos"}
                  titleCondominium={`Condominio: ${condominium}`}
                  titleProperty={"Datos del inmueble"}
                  titleInvoice={"Datos adicionales"}
                  condominium={[
                    {
                      label: "Documento de identificación",
                      value: phone || "No disponible",
                    },
                    /*     {
                        label: "Teléfono",
                        value: userData.phone || "No disponible",
                      }, */
                    { label: "Dirección", value: address },
                  ]}
                  property={[
                    {
                      label: "Propietario",
                      value: `${cost?.user?.data?.firstname || debt?.accounts?.[0]?.property?.user?.data?.firstname || ""} ${cost?.user?.data?.lastname || debt?.accounts?.[0]?.property?.user?.data?.lastname || ""}`,
                    },
                    {
                      label: "Teléfono",
                      value: cost?.user?.data?.phone || debt?.accounts?.[0]?.property?.user?.data?.phone || "No disponible",
                    },
                    {
                      label: "Inmueble",
                      value: `${debt?.accounts?.[0]?.property?.property || "No disponible"
                        }`,
                    },
                    {
                      label: "Alícuota",
                      value: (aliquots?.value ? aliquots.value / 100 : debt?.accounts?.[0]?.aliquot || 0).toFixed(4),
                    },
                  ]}
                  invoice={[
                    ...(debt?.control_number
                      ? [{ label: "N° de control", value: debt.control_number }]
                      : []),
                    {
                      label: "Fecha de emisión",
                      value: debt ? fechaFormateadaE : "No disponible",
                    },
                    {
                      label: "Fecha de vencimiento",
                      value: debt?.end_at ? fechaFormateada : "No disponible",
                    },
                    {
                      label: "Período",
                      value: debt?.name || "No disponible",
                    },
                    {
                      label: "Tasa de cambio",
                      value:
                        Boolean(curr?.currency?.iso) &&
                        Number(debt?.exchange_rate?.value || curr?.value || 0) > 0 ? (
                          <>
                            <NumberFormat
                              displayType="text"
                              prefix={`${baseCurrency.symbol} `}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={1}
                            />
                            <NumberFormat
                              displayType="text"
                              prefix={` | ${curr.currency.iso} `}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={Number(debt?.exchange_rate?.value || curr?.value)}
                            />
                            {` (${activeRateDateLabel})`}
                          </>
                        ) : (
                          "No disponible"
                        ),
                    },
                  ]}
                  loading={loadingConfig}
                />

                {debt && (
                  // mb-3 como el resto de los bloques: con mt-1 mb-2 quedaba
                  // pegado a las tarjetas de datos de arriba (HO-TASK-247).
                  <div className="border border-200 rounded mb-3">
                    <Row className="g-0 text-center text-sm-left">
                      <Col xs={12} sm={4} className="pl-4 pr-3 py-1">
                        <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                          Monto total
                        </div>
                        <div className="fs-0 font-weight-bold text-900">
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={finalTotal}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={debt?.total_bs ?? finalTotal * (curr?.value || 0)}
                            />
                          </div>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        sm={4}
                        className="pl-3 pr-4 py-1 border-left border-200"
                      >
                        <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                          Monto abonado
                        </div>
                        <div className="fs-0 font-weight-bold text-900">
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={paidAmount}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={debt?.paid_bs ?? paidAmount * (debt.exchange_rate?.value || curr?.value || 0)}
                            />
                          </div>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        sm={4}
                        className="pl-3 pr-4 py-1 border-left border-200"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-0">
                          <span className="fs--1 text-600 font-weight-semi-bold">
                            Saldo pendiente
                          </span>
                          <Badge className={classNames("rounded-capsule", balanceBadge.className)}>
                            {balanceBadge.label}
                          </Badge>
                        </div>
                        <div
                          className={classNames(
                            "fs-0 font-weight-bold",
                            isFullyPaid ? "text-900" : "text-warning"
                          )}
                        >
                          <NumberFormat
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={pendingAmount}
                          />
                        </div>
                        {curr?.currency?.iso && (
                          <div className="fs--1 text-600">
                            <NumberFormat
                              displayType="text"
                              prefix={curr.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={debt?.total_amount_bs ?? pendingAmount * (curr?.value || 0)}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}

                {isIterableArray(banks) && (
                  <CardBody
                    className={classNames("fs--1", {
                      "p-0": isIterableArray(banks),
                    })}
                  >
                    {" "}
                    <Card
                      title="Bancos"
                      style={{ border: "1px solid rgba(0, 0, 0, .1)" }}
                      className="mb-3 shadow-none"
                    >
                      <CardTitle className="bg-light text-dark text-center p-0 m-0">
                        <h5>Datos de pago</h5>
                      </CardTitle>
                      <PreloadState
                        cond={isIterableArray(banks)}
                        loading={loadingBanks}
                      >
                        <Or value={true}>
                          {/* HO-TASK-247: mismas columnas que la planilla del
                          reporte y que el PDF del correo. Antes la cabecera
                          declaraba 4 columnas y BankListItem pintaba 7 celdas
                          (incluidas correo y fecha de registro), así que los
                          datos no coincidían con su encabezado. */}
                          <Table responsive className=" fs--1">
                            <thead>
                              <tr>
                                <th className="border-0">DNI</th>
                                <th className="border-0">Banco</th>
                                <th className="border-0">Titular</th>
                                <th className="border-0">Moneda</th>
                                <th className="border-0">Número de cuenta</th>
                              </tr>
                            </thead>
                            <tbody>
                              {banks.map((bank, index) => (
                                <tr key={bank?.bank_id || index}>
                                  <td className="align-middle">
                                    <b>{bank?.owner_dni || "-"}</b>
                                  </td>
                                  <td className="align-middle">
                                    {bank?.name || "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.owner_name || "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.currency?.iso
                                      ? `(${bank.currency.iso}) ${bank.currency.name || ""}`.trim()
                                      : "-"}
                                  </td>
                                  <td className="align-middle">
                                    {bank?.account_number || "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Or>
                      </PreloadState>
                    </Card>
                  </CardBody>
                )}

                {report && report?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">Gastos ordinarios</th>
                          {/* <th className="border-0">Proveedor</th> */}
                          <th className="border-0">Descripción</th>
                          <th className="border-0 text-center" style={{ whiteSpace: "nowrap" }}>Fecha del gasto</th>
                          <th className="border-0 text-right" style={{ whiteSpace: "nowrap" }}>Tasa del día</th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {report.map((cuenta, index) => (
                          <tr key={index}>
                            <td
                              className="align-middle col-3"
                              style={{ width: "30%" }}
                            >
                              {" "}
                              <h6 className="mb-0">
                                {cuenta?.name
                                  ? cuenta?.name
                                  : cuenta.finance.name}{" "}
                              </h6>
                            </td>
                            {/* <td
                              className="align-middle"
                              style={{ width: "20%" }}
                            >
                              {" "}
                              {cuenta.provider_name != null
                                ? cuenta.provider_name
                                : cuenta?.finance?.provider?.name}
                            </td> */}
                            <td
                              className="align-middle"
                              style={{ width: "30%" }}
                            >
                              {cuenta?.description
                                ? cuenta?.description
                                : cuenta.finance.description}
                            </td>
                            <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>
                              {moment(cuenta.expense_date || cuenta?.finance?.expired_at).format("DD MMM YYYY")}
                            </td>
                            <td className="align-middle text-right" style={{ whiteSpace: "nowrap" }}>
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={getRateForRow(cuenta)}
                              />
                            </td>

                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={cuenta?.finance?.value}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  value={
                                    cuenta?.finance_amount_converted ?? Number(cuenta?.finance?.value || 0) * getRateForRow(cuenta)
                                  }
                                />
                              </span>
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(cuenta.amount)}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  value={cuenta.amount * getRateForRow(cuenta)}
                                />
                              </span>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={5} className="text-900">Total de gastos ordinarios</th>
                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amount}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                value={getConvertedTotal(report)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportE && reportE?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">
                            Gastos extraordinarios
                          </th>
                          {/* <th className="border-0">Proveedor</th> */}
                          <th className="border-0">Descripción</th>
                          <th className="border-0 text-center" style={{ whiteSpace: "nowrap" }}>Fecha del gasto</th>
                          <th className="border-0 text-right" style={{ whiteSpace: "nowrap" }}>Tasa del día</th>
                          <th className="border-0 text-right">Monto</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportE.map((cuenta, index) => (
                          <tr key={index}>
                            <td
                              className="align-middle col-3"
                              style={{ width: "30%" }}
                            >
                              {" "}
                              <h6 className="mb-0">
                                {cuenta?.name
                                  ? cuenta?.name
                                  : cuenta?.finance?.name}{" "}
                              </h6>
                            </td>
                            {/* <td
                              className="align-middle"
                              style={{ width: "20%" }}
                            >
                              {" "}
                              {cuenta?.provider_name != null
                                ? cuenta?.provider_name
                                : cuenta?.finance?.provider?.name}
                            </td> */}
                            <td
                              className="align-middle"
                              style={{ width: "30%" }}
                            >
                              {cuenta?.description
                                ? cuenta?.description
                                : cuenta?.finance?.description}
                            </td>
                            <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>
                              {moment(cuenta.expense_date || cuenta?.finance?.expired_at).format("DD MMM YYYY")}
                            </td>
                            <td className="align-middle text-right" style={{ whiteSpace: "nowrap" }}>
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={getRateForRow(cuenta)}
                              />
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={cuenta?.finance?.value}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  value={
                                    cuenta?.finance_amount_converted ?? Number(cuenta?.finance?.value || 0) * getRateForRow(cuenta)
                                  }
                                />
                              </span>
                            </td>
                            <td
                              className="align-middle text-right"
                              style={{ width: "20%" }}
                            >
                              <span className="d-block font-weight-semi-bold">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(cuenta?.amount)}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  value={cuenta?.amount * getRateForRow(cuenta)}
                                />
                              </span>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={5} className="text-900">Total de gastos extraordinarios</th>
                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountE}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                value={getConvertedTotal(reportE)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportI && reportI?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">
                            Gastos particulares
                          </th>
                          {/*       <th className="border-0">Proveedor</th> */}
                          <th className="border-0">Descripción</th>
                          <th className="border-0 text-center" style={{ whiteSpace: "nowrap" }}>Fecha del gasto</th>
                          <th className="border-0 text-right" style={{ whiteSpace: "nowrap" }}>Tasa del día</th>
                          <th className="border-0 text-right">Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {reportI.map((cuenta, index) => (
                            <tr key={index}>
                              <td
                                className="align-middle col-3"
                                style={{ width: "30%" }}
                              >
                                {" "}
                                <h6 className="mb-0">
                                  {cuenta?.name
                                    ? cuenta?.name
                                    : cuenta.finance.name}{" "}
                                </h6>
                              </td>
                              {/*  <td
                                className="align-middle"
                                style={{ width: "20%" }}
                              >
                                {" "}
                                {cuenta.provider_name != null
                                  ? cuenta.provider_name
                                  : cuenta?.finance?.provider?.name}
                              </td> */}
                              <td
                                className="align-middle"
                                style={{ width: "30%" }}
                              >
                                {cuenta?.description
                                  ? cuenta?.description
                                  : cuenta.finance.description}
                              </td>
                              <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>
                                {moment(cuenta.expense_date || cuenta?.finance?.expired_at).format("DD MMM YYYY")}
                              </td>
                              <td className="align-middle text-right" style={{ whiteSpace: "nowrap" }}>
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={getRateForRow(cuenta)}
                                />
                              </td>
                              <td
                                className="align-middle text-right"
                                style={{ width: "20%" }}
                              >
                                <span className="d-block font-weight-semi-bold">
                                  <NumberFormat
                                    className="text-nowrap"
                                    displayType="text"
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    value={roundAmount(cuenta.amount)}
                                  />
                                </span>
                                <span className="d-block text-700 fs--2 text-nowrap">
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={(curr?.currency?.iso ?? "") + " "}
                                    value={
                                      Number(cuenta.amount || 0) * getRateForRow(cuenta)
                                    }
                                  />
                                </span>
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <th colSpan={4} className="text-900">Total de gastos particulares</th>
                            <td className="align-middle text-right font-weight-semi-bold">
                              <span className="d-block">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={amountI}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={(curr?.currency?.iso ?? "") + " "}
                                  value={getConvertedTotal(reportI)}
                                />
                              </span>
                            </td>
                          </tr>
                        </>
                      </tbody>
                    </Table>
                  </div>
                )}

                {funds && funds?.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0">Fondos de reserva</th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0 text-center" style={{ whiteSpace: "nowrap" }}>Fecha del gasto</th>
                          <th className="border-0 text-right" style={{ whiteSpace: "nowrap" }}>Tasa del día</th>
                          <th className="border-0 text-right">Cuota</th>
                        </tr>
                      </thead>
                      <tbody>
                        {funds.map(
                          (cuenta, index) =>
                            cuenta.reserve_fund != null && (
                              <tr key={index}>
                                <td
                                  className="align-middle"
                                  style={{ width: "35%" }}
                                >
                                  {" "}
                                  {cuenta.reserve_fund.name}
                                </td>
                                <td
                                  className="align-middle"
                                  style={{ width: "40%" }}
                                >
                                  {" "}
                                  {cuenta.reserve_fund.description}
                                </td>
                                {/* Un fondo de reserva no nace de un gasto: va con la
                                    tasa del día, la misma del total a pagar. */}
                                <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>
                                  {activeRateDateLabel}
                                </td>
                                <td className="align-middle text-right" style={{ whiteSpace: "nowrap" }}>
                                  <NumberFormat
                                    className="text-nowrap"
                                    displayType="text"
                                    prefix={(curr?.currency?.iso ?? "") + " "}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    value={Number(debt?.exchange_rate?.value || curr?.value || 0)}
                                  />
                                </td>
                                <td
                                  className="align-middle text-right"
                                  style={{ width: "25%" }}
                                >
                                  <span className="d-block font-weight-semi-bold">
                                    <NumberFormat
                                      className="text-nowrap"
                                      displayType="text"
                                      prefix={`${baseCurrency.symbol} `}
                                      allowedDecimalSeparators={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator={true}
                                      value={roundAmount(cuenta.amount)}
                                    />
                                  </span>
                                  <span className="d-block text-700 fs--2 text-nowrap">
                                    <NumberFormat
                                      className="text-right text-nowrap"
                                      displayType="text"
                                      allowedDecimalSeparators={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator={true}
                                      prefix={(curr?.currency?.iso ?? "") + " "}
                                      value={
                                        cuenta?.amount_converted ?? Number(cuenta.amount || 0) * Number(curr?.value || 0)
                                      }
                                    />
                                  </span>
                                </td>
                              </tr>
                            )
                        )}
                        <tr>
                          <th colSpan={4} className="text-900">Total fondo de reserva</th>
                          <td className="align-middle text-right font-weight-semi-bold">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountF}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                value={getConvertedTotal(funds)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                {reportIncomes && reportIncomes.length > 0 && (
                  <div className="table-responsive mt-4 fs--1">
                    <Table striped className="border-bottom">
                      <thead>
                        <tr>
                          <th className="border-0 col-3">Ingresos aplicados</th>
                          <th className="border-0">Descripción</th>
                          <th className="border-0 text-center" style={{ whiteSpace: "nowrap" }}>Fecha del ingreso</th>
                          <th className="border-0 text-right" style={{ whiteSpace: "nowrap" }}>Tasa del día</th>
                          <th className="border-0 text-right">Descuento</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportIncomes.map((cuenta, index) => (
                          <tr key={index}>
                            <td className="align-middle col-3" style={{ width: "30%" }}>
                              <h6 className="mb-0">{cuenta.name || cuenta?.income?.name || "Ingreso a planilla"}</h6>
                            </td>
                            <td className="align-middle" style={{ width: "30%" }}>
                              {cuenta.description || cuenta?.income?.description}
                            </td>
                            <td className="align-middle text-center" style={{ whiteSpace: "nowrap" }}>
                              {moment(cuenta.expense_date || cuenta.created_at).format("DD MMM YYYY")}
                            </td>
                            <td className="align-middle text-right" style={{ whiteSpace: "nowrap" }}>
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={(curr?.currency?.iso ?? "") + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={getRateForRow(cuenta)}
                              />
                            </td>
                            <td className="align-middle text-right" style={{ width: "25%" }}>
                              <span className="d-block font-weight-semi-bold text-success">
                                <NumberFormat
                                  className="text-nowrap"
                                  displayType="text"
                                  prefix={`- ${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={roundAmount(Math.abs(cuenta.amount))}
                                />
                              </span>
                              <span className="d-block text-700 fs--2 text-nowrap text-success">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  prefix={"- " + (curr?.currency?.iso ?? "") + " "}
                                  value={Math.abs(cuenta.amount) * getRateForRow(cuenta)}
                                />
                              </span>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th colSpan={4} className="text-900">Total ingresos descontados</th>
                          <td className="align-middle text-right font-weight-semi-bold text-success">
                            <span className="d-block">
                              <NumberFormat
                                className="text-nowrap"
                                displayType="text"
                                prefix={`- ${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={amountIncomes}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap text-success">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                prefix={"- " + (curr?.currency?.iso ?? "") + " "}
                                value={getConvertedTotal(reportIncomes)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}

                <Row noGutters className="justify-content-end">
                  {curr?.currency?.iso && curr?.value > 0 && (
                    <Col xs={12} md className="order-2 order-md-1 text-600 fs--1 mt-n2 mt-md-0 pt-md-1 pr-md-3">
                      El monto total a pagar en bolívares es calculado en base a la tasa de cambio del día {activeRateDateLabel}
                    </Col>
                  )}
                  <Col xs="auto" className="order-1 order-md-2">
                    <Table
                      striped
                      size="sm"
                      borderless
                      className="fs--1 text-right"
                    >
                      <tbody>
                        <tr className="border-top">
                          <th className="text-900">Total:</th>
                          <td className="font-weight-semi-bold">
                            <NumberFormat
                              className="text-right"
                              displayType="text"
                              allowedDecimalSeparators={true}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale
                              prefix={`${baseCurrency.symbol} `}
                              value={finalTotal}
                            />
                            <NumberFormat
                              className="text-right"
                              displayType="text"
                              allowedDecimalSeparators={true}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale
                              prefix={" | " + (curr?.currency?.iso ?? "") + " "}
                              value={debt?.total_bs ?? finalTotal * (curr?.value || 0)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                {loadingConfig ? (
                  <Spinner />
                ) : (
                  <div className="text-start text-muted mt-3 pt-1 mb-0">
                    <Logo
                      to={null}
                      styleImage={{
                        width: "100px",
                      }}
                      className={"mb-2"}
                    />
                    <div className="mb-0">
                      {planillaNote !== "" && (
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          className="mr-2"
                          size="sm"
                        />
                      )}
                      <pre
                        style={{
                          fontFamily: "Open Sans",
                          fontSize: ".83333rem",
                          color: "#5e6e82",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {planillaNote}
                      </pre>
                    </div>
                  </div>
                )}
                {/*    </PreloadState> */}
              </CardBody>
            </Card>
          </Fragment>
        </PreloadState>
      </>
    </Fragment>
  );
};

export default withRedirect(PropertyPaymentDetail);
